// src/components/Footer.js
import React from 'react';
import './Footer.css';  // Assurez-vous de créer ce fichier CSS

function Footer() {
    return (
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} Yuzult. All rights reserved.</p>
        </footer>
    );
}


export default Footer;
